import { Fragment } from 'react';
import PropTypes from 'prop-types';
import Container from './Container';

const Features = ({ title, content, ...props }) => (
  <div className="features" {...props}>
    <Container>
      {title && (
        <h2 className="features__title">
          {title}
        </h2>
      )}
      <div className="features__content content">
        {content.map(({ title, text }) => (
          <Fragment key={title}>
            <h3>
              {title}
            </h3>
            {text.map((paragraph, i) => (
              <p key={`${title}:${i}`}>
                {paragraph}
              </p>
            ))}
          </Fragment>
        ))}
      </div>
    </Container>
  </div>
);

Features.propTypes = {
  title: PropTypes.string,
  content: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    text: PropTypes.arrayOf(PropTypes.string).isRequired,
  })).isRequired,
};

export default Features;
